import { ITreeItemResponse } from '@kcftech/prometheustypescriptapiclient';
import {
    QueryObserverResult,
    skipToken,
    useQuery,
    UseQueryOptions,
} from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';

/**
 * Loads a tree item. Returns `undefined` if `groupId` is undefined.
 *
 * @param groupId The id of the group to load.
 */
export function useTreeItem(
    groupId: string | null | undefined,
    options?: UseQueryOptions<ITreeItemResponse | undefined>
): QueryObserverResult<ITreeItemResponse | undefined, unknown> {
    return useQuery({
        queryKey: ['workbench-group', groupId],

        queryFn:
            !groupId || groupId === ''
                ? skipToken
                : async () => sdClient.getTreeItem({ treeItemId: groupId }),

        ...options,
    });
}
